"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.C360_ANCHOR_PRODUCT_TO_PLACEMENT_MAP = exports.C360_ANCHOR_STEP_TO_PAGE_MAP = exports.C360_ACTION_CONFIG = exports.C360_CLIENT_NAME = void 0;
exports.C360_CLIENT_NAME = 'multi-product-client';
exports.C360_ACTION_CONFIG = {
    rendered: {
        id: 'ctd_store__connected_trip_distribution_rendered',
        version: '3.3.0',
    },
    viewed: {
        id: 'ctd_store__connected_trip_distribution_viewed',
        version: '2.4.0',
    },
    interaction: {
        id: 'ctd_store__connected_trip_distribution_customer_interaction',
        version: '1.0.0',
    },
    book_process: {
        id: 'ctd_store__connected_trip_distribution_book_process',
        version: '1.0.0',
    },
};
exports.C360_ANCHOR_STEP_TO_PAGE_MAP = {
    FLIGHT: {
        select: 'flights_extras',
        checkout: 'flights_checkout',
        confirmation: 'flights_confirmation',
    },
    ACCOMMODATION: {},
    INSURANCE: {},
    TAXI: {},
};
exports.C360_ANCHOR_PRODUCT_TO_PLACEMENT_MAP = {
    FLIGHT: {
        INSURANCE: 'insurance_card',
    },
    ACCOMMODATION: {},
    INSURANCE: {},
    TAXI: {},
};
